import { Content, ContentHeader, FilterMenu, Table, TableBody, TableCell, TableHead, TableRow } from 'src/app/components'
import { WinnerModel } from 'src/app/modules/campaign/models/LuckyDraw.model'

import dayjs from 'dayjs'
import { FilterMenuContentLuckyDraw } from '../../FilterMenuContentLuckyDraw/FilterMenuContentLuckyDraw.component'

export interface TabWinnerConsolationProps {
    data?: WinnerModel[]
}

export default function TabWinnerConsolation({ data }: TabWinnerConsolationProps) {

    const renderItem = (item: WinnerModel, index: number) => {
        return (
            <TableRow key={item.id}>
                <TableCell {...{ index }} />
                <TableCell value={item?.prize?.name} />
                <TableCell value={item?.member?.member_code} />
                <TableCell value={item?.member?.fullname} />
                <TableCell value={item?.member?.phone_number} />
                <TableCell value={item?.member?.email} />
                <TableCell
                    renderValue={(_) => dayjs(_).format('DD/MM/YYYY')}
                    className="w-[145px]"
                    value={item?.draw_date}
                />
                <TableCell value={item?.draw_directory?.directory_name} />
            </TableRow>
        )
    }

    return (
        <Content>
            <ContentHeader title="Consolation Prize">
                <FilterMenu>
                    <FilterMenuContentLuckyDraw withStatusInactive={false}
                        withStatusPending={false}
                        withStatusActive={false}
                        withStatusDraft={false}
                        withStatus={false}
                        withCampaignType={false}
                        withPeriod={false} />
                </FilterMenu>
            </ContentHeader>

            <div className="px-8">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell index />
                            <TableCell>Prize Name</TableCell>
                            <TableCell>Customer ID</TableCell>
                            <TableCell>Customer Name</TableCell>
                            <TableCell>Phone Number</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Draw Date</TableCell>
                            <TableCell>Draw Location</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map(renderItem)}
                    </TableBody>
                </Table>
            </div>
        </Content>
    )
}
